import { render, staticRenderFns } from "./FormularioCovid.vue?vue&type=template&id=c8e306e8&scoped=true&"
import script from "./FormularioCovid.vue?vue&type=script&lang=js&"
export * from "./FormularioCovid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e306e8",
  null
  
)

export default component.exports